import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { DangerousHTMLDiv } from 'ecs-react-components/dist/index.es';
import { getLocalizedFacilityStringContent } from '../../redux/modules/localization/localization-middleware';

import Header from '../../components/Header/Header';
import { messages } from './UsefulLinks.i18n';

class UsefulLinks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usefulLinks: '',
    };
  }

  UNSAFE_componentWillMount = () => {
    const callback = (response) => {
      const item = document.createElement('textarea');
      item.innerHTML = response.data;
      this.setState({ usefulLinks: item.value });
    };

    getLocalizedFacilityStringContent(this.props.facilityId, this.props.languageCode, 'usefulLinksContent', callback);
  }

  render() {
    const {
      usefulLinks,
    } = this.state;

    return (
    <div className="useful-links-content" >
      <div className="col">
        <Header
          headerTitle={ <FormattedMessage { ...messages.page.title } /> }
          data-qa-item="pageHeader"
          headerClassName="mb-3"
        />
        {
          usefulLinks ?
          <DangerousHTMLDiv
            qaTag="usefulLinks"
            className="useful-links"
            html={ this.state.usefulLinks }
          /> :
            null
        }
      </div>
    </div>
    );
  }
}

UsefulLinks.propTypes = ({
  dispatch: PropTypes.func,
  facilityId: PropTypes.string,
  languageCode: PropTypes.string,
});

const mapStateToProps = (state) => ({
  facilityId: state.facility.facilityId,
  languageCode: state.language.languageCode,
});

export default connect(mapStateToProps)(UsefulLinks);